
import React, { useEffect } from 'react';
import { CheckCircle2, AlertTriangle, XCircle, Info, X } from 'lucide-react';

export type ToastType = 'success' | 'warning' | 'error' | 'info';

export interface ToastMessage {
  id: string;
  type: ToastType;
  message: string;
}

interface ToastProps {
  toast: ToastMessage;
  onClose: (id: string) => void;
}

export const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(toast.id), 4000);
    return () => clearTimeout(timer);
  }, [toast.id, onClose]);

  const getIcon = () => {
    switch (toast.type) {
      case 'success': return <CheckCircle2 className="w-5 h-5 text-white" />;
      case 'warning': return <AlertTriangle className="w-5 h-5 text-white" />;
      case 'error': return <XCircle className="w-5 h-5 text-white" />;
      default: return <Info className="w-5 h-5 text-white" />;
    }
  };

  const getBg = () => {
    switch (toast.type) {
      case 'success': return 'bg-green-600 border-green-500';
      case 'warning': return 'bg-amber-600 border-amber-500';
      case 'error': return 'bg-red-600 border-red-500';
      default: return 'bg-zinc-900 border-zinc-800';
    }
  };

  return (
    <div className={`flex items-center gap-3 p-4 pr-3 rounded-2xl shadow-2xl border min-w-[300px] animate-in slide-in-from-top-4 fade-in duration-300 ${getBg()}`}>
      <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center shrink-0">
        {getIcon()}
      </div>
      <div className="flex-1">
        <p className="text-[10px] font-black uppercase tracking-widest text-white/70">Findily Update</p>
        <p className="text-sm font-black text-white tracking-tight leading-tight">{toast.message}</p>
      </div>
      <button onClick={() => onClose(toast.id)} className="p-1.5 hover:bg-white/10 rounded-full transition-colors text-white/50 hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
